import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api, photoUrl } from "@/lib/api";
import { usePhotos } from "@/hooks/usePhotos";
import { Lightbox } from "@/components/Photo";

export const useAnnouncements = () => {
  const [list, setList] = useState([]);
  useEffect(() => {
    let on = true;
    api.get("/announcements").then((r) => on && setList(r.data)).catch(() => {});
    return () => { on = false; };
  }, []);
  return list;
};

export const AnnouncementBar = ({ list }) => {
  const { photos } = usePhotos("announcement");
  const [lb, setLb] = useState(null);
  if (!list.length) return null;
  const posters = list.map((a) => photos.find((p) => p.id === a.photo_id)).filter(Boolean);
  return (
    <section data-testid="announcements-section" className="mx-auto max-w-[1400px] px-3 pt-28 sm:px-6 sm:pt-32">
      <div className="space-y-6">
        {list.map((a, i) => {
          const poster = photos.find((p) => p.id === a.photo_id);
          return (
            <motion.div
              key={a.id}
              data-testid={`announcement-${i}`}
              initial={{ opacity: 0, y: -12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
            >
              {poster && (
                <button
                  type="button"
                  data-testid={`announcement-poster-${i}`}
                  onClick={() => setLb(posters.indexOf(poster))}
                  aria-label="View announcement poster"
                  className="mx-auto block cursor-zoom-in"
                >
                  <img src={photoUrl(poster)} alt={a.text || "Announcement"} loading={i === 0 ? "eager" : "lazy"} decoding="async" className="mx-auto block h-auto max-h-[80vh] w-auto max-w-full rounded-2xl object-contain" />
                </button>
              )}
              {a.text && (
                <p className={`mx-auto max-w-3xl text-center font-display text-lg font-bold leading-relaxed text-forest sm:text-xl ${poster ? "mt-4" : ""}`}>{a.text}</p>
              )}
            </motion.div>
          );
        })}
      </div>
      <Lightbox photos={posters} index={lb} onClose={() => setLb(null)} onIndex={setLb} showCaptions={false} />
    </section>
  );
};
